// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"361":"17cbc813","453":"378a716a","482":"64a4aca2"}[chunkId] + ".chunk.js";
};